module.exports = __webpack_public_path__ + "img/redRupee.99b0c9b0.svg";